import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import {
  DateTimeField,
  NumberField,
  RelationshipField,
  StringField,
} from "../plugins/Cruxtify/field-types";

import {
  DateTimeProperty,
  NumberProperty,
  RelationshipProperty,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import { ErCrudModel } from "./ErCrudModel";

export class SubmissionEvent extends ErCrudModel {
  protected static _typeLabel = "SubmissionEvent";
  protected static asProperty = "submission-event";
  public static api = {
    path: "submission-events",
  };
  protected static routeBase = "submission-events";
  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Read,
    },
    UserPermission.Hidden
  );

  protected userIdField = [];

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Entry Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Entry Updated At",
        userPermissions: UserPermission.Hidden,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "event",
        label: "Event",
      },
    },

    {
      type: RelationshipProperty,
      opts: {
        name: "submission",
        label: "Case Submission",
        relatedModel: "Submission",
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    {
      type: DateTimeField,
      opts: { property: "created_at" },
    },
    {
      type: StringField,
      opts: {
        property: "event",
        viewComponentName: "submission-event-message",
      },
    },
    {
      type: RelationshipField,
      opts: {
        property: "submission",
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["created_at", "event", "submission"],
      disableRowClick: true,
      defaultSort: [
        {
          field: "created_at",
          order: "desc",
        },
      ],
    },
  ];
}
